import { FETCH_ORGANIZATIONS_FULFILLED } from './actions';

import type { Organization } from '@/types/organization';

interface OrganizationsAction {
  type: string;
  payload?: Organization[];
}

const organizationsReducer = (
  state: Organization[] = [],
  action: OrganizationsAction
): Organization[] => {
  if (action.type === FETCH_ORGANIZATIONS_FULFILLED) {
    return action.payload ?? [];
  } else {
    return state;
  }
};

export { organizationsReducer };
